<template>
<grid class="social-register" flat>
	<grid-item size="1/2">
		<a class="button google-button">
			<i class="icon-gplus-1"></i>
			Sign up with google
		</a>
	</grid-item>
	<grid-item size="1/2">
		<a class="button linkedin-button">
			<i class="icon-linkedin-2"></i>
			Sign up with linked in
		</a>
	</grid-item>
</grid>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.social-register {
	width: 84%;
	margin: 0 auto !important;

	.button {
		font-size: 10px;
		padding: 7px 0;
		width: 95%;

		i {
			font-size: 14px;
		}
	}
	.google-button {
		background: #dd4d31;
	}
	.linkedin-button {
		background: #41a9d7;
	}
}
</style>
